// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tranier-simulator {
    min-height: 100vh;
    background-color: #0f0125;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 100px 0px;
}

.tranier-simulator .profile-sec-wrap {
    justify-content: space-between;
    max-width: 750px;
    margin: 0 auto;
    position: relative;
}

.tranier-simulator .profile-sec-wrap .arrow-img-wrap {
    text-align: center;
    position: absolute;
    top: 15%;
    display: block;
    right: -52%;
}

.tranier-simulator .logo-img {
    max-width: 150px;
    margin-bottom: 20px;
}

.tranier-simulator .heading {
    font-size: 26px;
    font-weight: 700;
    line-height: 75px;
    color: white;
    text-align: center;
    margin-bottom: 50px;
    width: unset;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .user-name {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #ffff;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .user-name span {
    font-weight: 700;
}

.tranier-simulator .icon-title {
    font-size: 12px;
    font-weight: 400;
    line-height: 35px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .profile-section {
    margin-bottom: 40px;
}

.tranier-simulator .profile-section .caller-title {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .profile-section .caller-name {
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .profile-img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-bottom: 10px;
}

.tranier-simulator .icons {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 10px;
}

.tranier-simulator .icon-button {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.tranier-simulator .icon-img {
    width: 40px;
    height: 40px;
}

.tranier-simulator .bottom-content {
    justify-content: center;
    overflow: hidden;
}

.tranier-simulator .bottom-content .description {
    max-width: 582px;
    margin: 0 auto;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    padding-bottom: 26px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .bottom-content .prepare-button {
    background-color: #06efc5;
    padding: 18px 59px;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    color: #242424;
    cursor: pointer;
    border-radius: 0px;
    display: inline-block;
    font-family: "Inter", sans-serif;
    width: 310px;
}

.tranier-simulator .bottom-content .prepare-button-mob {
    background-color: #06efc5;
    padding: 18px 59px;
    font-size: 18.33px;
    font-weight: 800;
    line-height: 13.33px;
    color: #242424;
    cursor: pointer;
    border-radius: 0px;
    display: none;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .bottom-content .prepare-button:focus {
    box-shadow: none;
}

.tranier-simulator .bottom-content .bottom-line {
    font-weight: 400;
    line-height: 20px;
    font-size: 16px;
    color: #ffff;
    padding: 18px 54px;
    background-color: #1e102d;
    width: max-content;
    margin: 28px auto 0px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .dropdown-wrap .title {
    font-size: 14px;
    line-height: 22px;
    font-weight: 400;
    text-align: left;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .dropdown-wrap {
    margin-top: 40px;
}

.tranier-simulator .dropdown-button {
    background-color: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    padding: 14px 20px 14px 12px;
    width: 550px;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-bottom: 20px;
    font-family: "Inter", sans-serif;
}

.tranier-simulator .dropdown-button.active {
    background-color: rgba(255, 255, 255, 0.1);
}

.tranier-simulator .dropdown-arrow {
    margin-left: 10px;
    transition: transform 0.3s ease;
}

.tranier-simulator .dropdown-arrow img {
    width: 16px;
    height: 16px;
}

.tranier-simulator .dropdown-list {
    list-style-type: none;
    padding: 0;
    margin: 10px auto;
    background-color: #0f0125;
    border: 1px solid #2b1155;
    width: 550px;
    position: absolute;
    z-index: 1000;
    left: 25.25%;
    top: 50px;
}

.tranier-simulator .dropdown-list li {
    padding: 12px;
    cursor: pointer;
    color: white;
    text-align: left;
}

.tranier-simulator .dropdown-selected-text {
    padding: 6px 22px;
    border-radius: 4px;
    color: white;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
}

.trainerIntro-drawerDataWrap {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.trainerIntro-drawerDataWrap .label {
    font-size: 16px;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: -0.02em;
    text-align: left;
    width: 100%;
}

.trainerIntro-drawerDataWrap-heading {
    font-size: 16px;
    font-weight: 700;
    line-height: 27px;
    letter-spacing: -0.02em;
    text-align: center;
}

.tranier-simulator .mobile-trainingSelect-button {
    display: none;
}

@media (max-width: 1650px) {
    .tranier-simulator {
        padding: 40px 0px 20px;
    }

    .tranier-simulator .logo-img {
        margin-bottom: 0px;
    }

    .tranier-simulator .heading {
        line-height: 40px;
        margin-bottom: 20px;
    }

    .tranier-simulator .bottom-content .description {
        padding-bottom: 10px;
    }

    .tranier-simulator .profile-section {
        margin-bottom: 20px;
    }
}

@media (max-width: 767px) {
    .tranier-simulator {
        padding: 50px 0px;
    }

    .tranier-simulator .profile-sec-wrap {
        min-width: unset;
    }

    .tranier-simulator .profile-img {
        width: 100px;
        height: 100px;
    }

    .tranier-simulator .heading {
        line-height: 24px;
        font-size: 16px;
        max-width: 320px;
        margin: 0 auto;
        padding-bottom: 30px;
        font-family: "Inter", sans-serif;
    }

    .tranier-simulator .profile-section .caller-title {
        font-size: 14px;
        line-height: 22px;
    }

    .tranier-simulator .profile-section .caller-name {
        font-size: 14px;
        line-height: 22px;
    }

    .tranier-simulator .bottom-content .description {
        font-size: 12px;
        line-height: 20px;
        opacity: 50%;
        margin-top: 20px;
    }

    .tranier-simulator .bottom-content .bottom-line {
        font-size: 10px;
    }

    .tranier-simulator .dropdown-button {
        width: 100%;
    }

    .tranier-simulator .dropdown-list {
        top: 0;
    }

    .tranier-simulator .bottom-content .prepare-button-mob {
        display: inline-block;
        width: 100%;
    }

    .tranier-simulator .bottom-content .prepare-button {
        display: none;
    }

    .tranier-simulator .profile-sec-wrap .arrow-img-wrap {
        display: none;
    }

    .tranier-simulator .desktop-trainingSelect-button {
        display: none;
    }

    .tranier-simulator .mobile-trainingSelect-button {
        display: block;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TrainerIntro/TrainerIntro.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,YAAY;IACZ,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,oBAAoB;QACpB,gCAAgC;IACpC;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,MAAM;IACV;;IAEA;QACI,qBAAqB;QACrB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":[".tranier-simulator {\n    min-height: 100vh;\n    background-color: #0f0125;\n    color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 100px 0px;\n}\n\n.tranier-simulator .profile-sec-wrap {\n    justify-content: space-between;\n    max-width: 750px;\n    margin: 0 auto;\n    position: relative;\n}\n\n.tranier-simulator .profile-sec-wrap .arrow-img-wrap {\n    text-align: center;\n    position: absolute;\n    top: 15%;\n    display: block;\n    right: -52%;\n}\n\n.tranier-simulator .logo-img {\n    max-width: 150px;\n    margin-bottom: 20px;\n}\n\n.tranier-simulator .heading {\n    font-size: 26px;\n    font-weight: 700;\n    line-height: 75px;\n    color: white;\n    text-align: center;\n    margin-bottom: 50px;\n    width: unset;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .user-name {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    color: #ffff;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .user-name span {\n    font-weight: 700;\n}\n\n.tranier-simulator .icon-title {\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 35px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .profile-section {\n    margin-bottom: 40px;\n}\n\n.tranier-simulator .profile-section .caller-title {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 22px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .profile-section .caller-name {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 22px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .profile-img {\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    margin-bottom: 10px;\n}\n\n.tranier-simulator .icons {\n    display: flex;\n    justify-content: center;\n    gap: 15px;\n    margin-top: 10px;\n}\n\n.tranier-simulator .icon-button {\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n}\n\n.tranier-simulator .icon-img {\n    width: 40px;\n    height: 40px;\n}\n\n.tranier-simulator .bottom-content {\n    justify-content: center;\n    overflow: hidden;\n}\n\n.tranier-simulator .bottom-content .description {\n    max-width: 582px;\n    margin: 0 auto;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    padding-bottom: 26px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .bottom-content .prepare-button {\n    background-color: #06efc5;\n    padding: 18px 59px;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    color: #242424;\n    cursor: pointer;\n    border-radius: 0px;\n    display: inline-block;\n    font-family: \"Inter\", sans-serif;\n    width: 310px;\n}\n\n.tranier-simulator .bottom-content .prepare-button-mob {\n    background-color: #06efc5;\n    padding: 18px 59px;\n    font-size: 18.33px;\n    font-weight: 800;\n    line-height: 13.33px;\n    color: #242424;\n    cursor: pointer;\n    border-radius: 0px;\n    display: none;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .bottom-content .prepare-button:focus {\n    box-shadow: none;\n}\n\n.tranier-simulator .bottom-content .bottom-line {\n    font-weight: 400;\n    line-height: 20px;\n    font-size: 16px;\n    color: #ffff;\n    padding: 18px 54px;\n    background-color: #1e102d;\n    width: max-content;\n    margin: 28px auto 0px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .dropdown-wrap .title {\n    font-size: 14px;\n    line-height: 22px;\n    font-weight: 400;\n    text-align: left;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .dropdown-wrap {\n    margin-top: 40px;\n}\n\n.tranier-simulator .dropdown-button {\n    background-color: rgba(255, 255, 255, 0.1);\n    color: white;\n    border: none;\n    padding: 14px 20px 14px 12px;\n    width: 550px;\n    font-size: 16px;\n    cursor: pointer;\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    font-family: \"Inter\", sans-serif;\n}\n\n.tranier-simulator .dropdown-button.active {\n    background-color: rgba(255, 255, 255, 0.1);\n}\n\n.tranier-simulator .dropdown-arrow {\n    margin-left: 10px;\n    transition: transform 0.3s ease;\n}\n\n.tranier-simulator .dropdown-arrow img {\n    width: 16px;\n    height: 16px;\n}\n\n.tranier-simulator .dropdown-list {\n    list-style-type: none;\n    padding: 0;\n    margin: 10px auto;\n    background-color: #0f0125;\n    border: 1px solid #2b1155;\n    width: 550px;\n    position: absolute;\n    z-index: 1000;\n    left: 25.25%;\n    top: 50px;\n}\n\n.tranier-simulator .dropdown-list li {\n    padding: 12px;\n    cursor: pointer;\n    color: white;\n    text-align: left;\n}\n\n.tranier-simulator .dropdown-selected-text {\n    padding: 6px 22px;\n    border-radius: 4px;\n    color: white;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 20px;\n}\n\n.trainerIntro-drawerDataWrap {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.trainerIntro-drawerDataWrap .label {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 27px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    width: 100%;\n}\n\n.trainerIntro-drawerDataWrap-heading {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 27px;\n    letter-spacing: -0.02em;\n    text-align: center;\n}\n\n.tranier-simulator .mobile-trainingSelect-button {\n    display: none;\n}\n\n@media (max-width: 1650px) {\n    .tranier-simulator {\n        padding: 40px 0px 20px;\n    }\n\n    .tranier-simulator .logo-img {\n        margin-bottom: 0px;\n    }\n\n    .tranier-simulator .heading {\n        line-height: 40px;\n        margin-bottom: 20px;\n    }\n\n    .tranier-simulator .bottom-content .description {\n        padding-bottom: 10px;\n    }\n\n    .tranier-simulator .profile-section {\n        margin-bottom: 20px;\n    }\n}\n\n@media (max-width: 767px) {\n    .tranier-simulator {\n        padding: 50px 0px;\n    }\n\n    .tranier-simulator .profile-sec-wrap {\n        min-width: unset;\n    }\n\n    .tranier-simulator .profile-img {\n        width: 100px;\n        height: 100px;\n    }\n\n    .tranier-simulator .heading {\n        line-height: 24px;\n        font-size: 16px;\n        max-width: 320px;\n        margin: 0 auto;\n        padding-bottom: 30px;\n        font-family: \"Inter\", sans-serif;\n    }\n\n    .tranier-simulator .profile-section .caller-title {\n        font-size: 14px;\n        line-height: 22px;\n    }\n\n    .tranier-simulator .profile-section .caller-name {\n        font-size: 14px;\n        line-height: 22px;\n    }\n\n    .tranier-simulator .bottom-content .description {\n        font-size: 12px;\n        line-height: 20px;\n        opacity: 50%;\n        margin-top: 20px;\n    }\n\n    .tranier-simulator .bottom-content .bottom-line {\n        font-size: 10px;\n    }\n\n    .tranier-simulator .dropdown-button {\n        width: 100%;\n    }\n\n    .tranier-simulator .dropdown-list {\n        top: 0;\n    }\n\n    .tranier-simulator .bottom-content .prepare-button-mob {\n        display: inline-block;\n        width: 100%;\n    }\n\n    .tranier-simulator .bottom-content .prepare-button {\n        display: none;\n    }\n\n    .tranier-simulator .profile-sec-wrap .arrow-img-wrap {\n        display: none;\n    }\n\n    .tranier-simulator .desktop-trainingSelect-button {\n        display: none;\n    }\n\n    .tranier-simulator .mobile-trainingSelect-button {\n        display: block;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
